@if (isUserLoggedIn)
{
  <div class="rnSidebarContainer">
    <app-rn-navigation-bar></app-rn-navigation-bar>
  </div>
}
